import {AxiosPromise} from "axios";
import {CONSTANT_CONFIG} from "@/constants";
import { HttpService } from "@/services/http.services";

const RESOURCE_ENDPOINT = `${CONSTANT_CONFIG.CORE_SERVER_PREFIX}/compilation-lock`
const endpoints = {
    compilationInfo: () => `${RESOURCE_ENDPOINT}/compilation-info`,
    saveCompilation: () => `${RESOURCE_ENDPOINT}/save-compilation`,
    progressData: () => `${RESOURCE_ENDPOINT}/progress-data`,
}

export default class CompilationLockApi {
    public compilationInfo =(payload = {}, params = {}, headers = {}): AxiosPromise<any> => {
        const url = endpoints.compilationInfo();
        return HttpService.post(url, payload, params, headers);
    }

    public saveCompilation = (payload = {}, params = {}, headers = {}): AxiosPromise<any> => {
        const url = endpoints.saveCompilation();
        return HttpService.post(url, payload, params, headers);
    }

    public progressData = (params = {}, headers = {}): AxiosPromise<any> => {
        const url = endpoints.progressData();
        return HttpService.get(url, params, headers);
    }
}
